import * as Yup from 'yup'

const Validation = Yup.object({
  file: Yup.object().shape({
    id: Yup.string().required('Attachment is required'),
  }),
})

export default Validation
